<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DataTable from "@/components/DataTable.vue";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "DISCOUNTS ALLOWED",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "DISCOUNTS ALLOWED",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "DISCOUNTS ALLOWED",
          active: true,
        },
      ],
     
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsDiscountsDataServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      discountsColumns: [
        { key: "sn", label: "S/N" },
        { key: "date", label: "DATE" },
        { key: "customer", label: "CUSTOMER" },
        { key: "tt_amt", label: "TOTAL" },
        { key: "discount_field", label: "DISCOUNT" },
        { key: "user", label: "USER" },
        { key: "addedon", label: "RECORDED ON" },
        { key: "receipt", label: "RECEIPT" },
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        customer: "",
        branch_id:0,
        receipt:'',
        page: 1,
        per_page: 50,
      },

    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("saledetails", ["SaveStatus","DiscountsData","DiscountsDataPagination","filterStatus","DiscountsDataSummary","DiscountsDataPaginated"]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("auth",["MyUserPerm","business","branch","Branches","branchid"]),
    ...mapGetters("setting", ["GeneralSettings",]),

    rows() {
      return this.IsDiscountsDataServerPaginated
          ? this.DiscountsDataPagination?.total
          : this.DiscountsData ? this.DiscountsData.length : 0;
    },

     perPage: {
      get() {
        if (this.IsDiscountsDataServerPaginated) {
          return (
            (this.DiscountsDataPagination &&
              this.DiscountsDataPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsDiscountsDataServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchDiscounts(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.DiscountsDataPaginated && this.DiscountsDataPagination
          ? this.DiscountsDataPagination.current_page
          : 1;
      },
      set(value) {
        if (this.DiscountsDataPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.DiscountsDataSummary || {
          totalAmount: 0,
          totalDiscount: 0,
        }
      );
    },
  },

  mounted() {
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },

    Discounts(newValue){
      if(newValue){
        this.SalesData();
      }
    }
  },

  methods: {
    ...mapActions({
      FetchDiscounts: "saledetails/fetchDiscounts",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",

    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

     filterReport() {
      let payload = { ...this.data };
      payload.page = 1;
      payload.per_page = this.IsDiscountsDataServerPaginated
        ? this.perPage
        : this.serverPerPage;

      this.FetchDiscounts(payload);
    },

   handlePageChange(newPage) {
      if (this.IsDiscountsDataServerPaginated) {
        this.data.page = newPage;
        this.FetchDiscounts(this.data);
      }
    },
  },

  created() {
    this.filterReport();
    this.FetchGeneralSettings();
    this.FetchBranches();
    this.FetchDiscounts(this.data);
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select
                    :list="Branches ? Branches : []"
                    v-model="data.branch_id"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Branch"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                      type="date"
                      v-model="data.datefrom"
                      class="form-control"
                      v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                      type="date"
                      v-model="data.dateto"
                      class="form-control"
                      v-limit-future-date
                  />
                </div>
              </div>


              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                      v-show="filterStatus"
                      variant="light"
                      small
                      role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class=" col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-md-4">

              </div>
              <!-- Search -->
              <div class="col-md-4">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                    v-if="!IsDiscountsDataServerPaginated"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="discountsColumns"
                :loading="filterStatus"
                row-class="discounts-table"
                :rows="DiscountsData"
                :total-rows="rows"
                :pagination="DiscountsDataPagination"
                :server-pagination="IsDiscountsDataServerPaginated"
              >
                <template #cell(sn)="{ row, index }">
                  {{ IsDiscountsDataServerPaginated ? (DiscountsDataPagination.from + index) : ((currentPage - 1) * perPage + index + 1) }}
                </template>

                <template #cell(date)="{ row }">
                  {{ row.date }}
                </template>

                <template #cell(customer)="{ row }">
                  {{ row.customer }}
                </template>

                <template #cell(tt_amt)="{ row, value }">
                  {{ thousandSeperator(row.totalAmt) }}
                </template>

                <template #cell(discount_field)="{ row }">
                  {{ thousandSeperator(row.discount) }}
                </template>

                <template #cell(user)="{ row }">
                  {{ row.user }}
                </template>

                <template #cell(addedon)="{ row }">
                  {{ row.addedon }}
                </template>

                <template #cell(receipt)="{ row }">
                  {{ row.receipt }}
                </template>
              </DataTable>

              <div class="row">
                <div class="col-md-3">
                  <h5>Total Amount: <span class="text-danger">{{thousandSeperator(DiscountsDataSummary.totalAmount)}}</span></h5>
                </div>

                <div class="col-md-3">
                  <h5>Total Discount: <span class="text-danger">{{thousandSeperator(DiscountsDataSummary.totalDiscount)}}</span></h5>
                </div>

              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="tickets-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
